export default __webpack_public_path__ + "static/jb-hifi-tile-eb6141c11ffa0f6f24d834c281e81f14.webp";